import { Download, ExternalLink } from 'lucide-react'
import { Button } from '../ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { inferFileKindFromUrl } from './chat-utils'

export default function DocumentPreviewModal({ open, onOpenChange, title, url, payloadSummary }) {
  const kind = url ? inferFileKindFromUrl(url) : null

  const handleDownload = () => {
    if (!url) return
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.rel = 'noopener noreferrer'
    link.download = title || 'document'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const handleOpenTab = () => {
    if (!url) return
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl w-[95vw] h-[90vh] flex flex-col p-0 gap-0">
        <DialogHeader className="px-6 py-4 border-b border-slate-200 shrink-0">
          <div className="flex items-start justify-between gap-4 pr-8">
            <DialogTitle className="text-left line-clamp-2">{title || 'Document'}</DialogTitle>
            {url && (
              <div className="flex items-center gap-2 shrink-0">
                <Button type="button" variant="outline" size="sm" onClick={handleOpenTab}>
                  <ExternalLink className="w-4 h-4 mr-1" />
                  Ouvrir
                </Button>
                <Button type="button" variant="outline" size="sm" onClick={handleDownload}>
                  <Download className="w-4 h-4 mr-1" />
                  Télécharger
                </Button>
              </div>
            )}
          </div>
        </DialogHeader>

        <div className="flex-1 min-h-0 bg-slate-100 overflow-hidden">
          {!url && payloadSummary ? (
            <div className="p-6 overflow-y-auto h-full">
              <div className="bg-white rounded-xl border border-slate-200 p-4 space-y-3 text-sm">
                {payloadSummary.map((row) => (
                  <div key={row.label} className="flex justify-between gap-4">
                    <span className="text-slate-500">{row.label}</span>
                    <span className="text-slate-900 font-medium text-right">{row.value}</span>
                  </div>
                ))}
              </div>
              <p className="text-sm text-slate-500 mt-4 text-center">
                Aucun fichier PDF disponible pour ce document structuré.
              </p>
            </div>
          ) : !url ? (
            <div className="flex items-center justify-center h-full text-slate-500 text-sm">
              Aucun fichier à afficher
            </div>
          ) : kind === 'image' ? (
            <div className="flex items-center justify-center h-full p-4 overflow-auto">
              <img
                src={url}
                alt={title || 'Document'}
                className="max-w-full max-h-full object-contain rounded-lg shadow-sm"
              />
            </div>
          ) : (
            <iframe
              src={url}
              title={title || 'Document'}
              className="w-full h-full border-0 bg-white"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
